import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { FacilityDocumentsService } from 'src/app/shared/services/facility-documents.service';
import { FacilityDocumentStatus } from 'src/app/shared/services/facility-documents.service';
import { FeatureFlagsService } from 'src/app/shared/services/featureFlags.service';

@Component({
  selector: 'app-facility-card',
  templateUrl: './facility-card.component.html',
  styleUrls: ['./facility-card.component.scss'],
})
export class FacilityCardComponent implements OnInit {
  @Input() facility: any;
  @Input() primaryFacilityId: any;
  @Input() userId: any;
  @Input() isReadOnly: boolean = false;
  @Output() switch = new EventEmitter<any>();

  status: FacilityDocumentStatus;
  showUsersPopup: boolean = false;

  constructor(private facilityDocumentsService: FacilityDocumentsService, public featureFlagsService: FeatureFlagsService) { }

  ngOnInit() {
    this.status = this.facilityDocumentsService.evaluateStatus(this.facility, [], true);
  }

  onSwitch() {
    this.switch.emit({ facility_id: this.facility.id, user_id: this.userId });
  }
}
